import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-insufficient-stock-modal',
  templateUrl: './insufficient-stock-modal.component.html',
  styleUrls: ['./insufficient-stock-modal.component.scss']
})
export class InsufficientStockModalComponent implements OnInit {
f
	products = new BehaviorSubject<any[]>([]);

	constructor(
		public dialogRef: MatDialogRef<InsufficientStockModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public _data: any) { }

	ngOnInit() {

		this.getProductInfo();
	}

	private getProductInfo() {

		this.products.next(this._data.products);
	}

	close() {

		this.dialogRef.close();
	}
}
